export const CALLS_TYPE_OPTIONS = [
    { id: 1, name: 'Забор' },
    { id: 2, name: 'Доставка' },
]
